module.exports = __webpack_public_path__ + "img/use_human_blue_1.c78b4b6b.png";